module.exports = __webpack_public_path__ + "static/media/fallasni-by-saad.firebaseapp.com_(Laptop with MDPI screen) (1).bc71f101.png";